import React from 'react';

import { Inline } from '@atlaskit/primitives/compiled/inline';
import { Stack } from '@atlaskit/primitives/compiled/stack';
import Tag from '@atlaskit/tag/removable-tag';
import { token } from '@atlaskit/tokens';

export default (): React.JSX.Element => (
	<Stack space="space.100">
		<Inline>
			<Tag text="Project A" color="blue" swatchBefore isRemovable={false} />
		</Inline>
		<Inline>
			<Tag
				text="Project B"
				color="blue"
				swatchBefore={token('color.background.accent.blue.subtler')}
				isRemovable={false}
			/>
		</Inline>
	</Stack>
);
